/* TEFCO storefront helpers. Loaded with defer from layout/theme.liquid. */
(function () {
  'use strict';

  /* ---------- RMS rules (pure, unit-tested) ---------- */
  var PACKS = [6, 12, 36, 60, 120]; // documented management pack durations, months

  function recommend(a, s) {
    // a: {q1,q2,q3,q4}; s: localized strings
    var out = [];
    if (a.q1 !== 'b') {
      if (a.q3 === 'a' || a.q2 === 'a') out.push(s.credits);
      else out.push(s.pack.replace('{duration}', a.q2 === 'b' ? s.pack6 : a.q2 === 'c' ? s.pack12 : s.packLong));
    }
    if (a.q1 !== 'a') out.push(a.q4 === 'b' ? s.dataPack : s.companyData);
    if (a.q1 === 'b') out.push(s.needsMgmt);
    return out;
  }

  function estimate(i) {
    // i: {dev, per (30-day periods), trial (bool), gb, newco (bool)}
    var dev = Math.max(0, Math.floor(i.dev || 0));
    var per = Math.max(0, Math.floor(i.per || 0));
    var billable = Math.max(0, per - (i.trial ? 1 : 0));
    var mgmt = dev * billable;
    var gbNeed = Math.max(0, (Number(i.gb) || 0) - (i.newco ? 5 : 0));
    var data = Math.ceil(gbNeed / 2); // 1 credit = 2 GB company data
    var months = Math.ceil(per * 30 / 30.42);
    var packIdx = PACKS.findIndex(function (p) { return p >= months; });
    if (packIdx < 0) packIdx = PACKS.length - 1;
    return { mgmt: mgmt, data: data, total: mgmt + data, packs: dev, packIdx: packIdx };
  }

  window.TefcoRms = { recommend: recommend, estimate: estimate, PACKS: PACKS };

  /* ---------- wiring ---------- */
  function track(e, p) { if (window.tefcoTrack) window.tefcoTrack(e, p); }

  function initSelector(root) {
    var i18nEl = document.querySelector('[data-tefco-i18n]');
    if (!i18nEl) return;
    var s = JSON.parse(i18nEl.textContent);
    var form = root.querySelector('[data-tefco-sel-form]');
    var out = root.querySelector('[data-tefco-rec]');
    function update() {
      var a = {};
      ['q1', 'q2', 'q3', 'q4'].forEach(function (q) {
        var el = form.querySelector('input[name="' + q + '"]:checked');
        a[q] = el ? el.value : '';
      });
      form.querySelectorAll('[data-for="mgmt"]').forEach(function (f) { f.hidden = a.q1 === 'b'; });
      form.querySelectorAll('[data-for="data"]').forEach(function (f) { f.hidden = a.q1 === 'a'; });
      out.innerHTML = '';
      recommend(a, s).forEach(function (txt) { var li = document.createElement('li'); li.textContent = txt; out.appendChild(li); });
      return a;
    }
    form.addEventListener('change', function () { track('rms_selector_answer', update()); });
    update();
  }

  function initCalc(root) {
    var i18nEl = document.querySelector('[data-tefco-i18n]');
    var s = i18nEl ? JSON.parse(i18nEl.textContent) : { packsN: '{n} × {d}', dur: ['6m', '1y', '3y', '5y', '10y'] };
    var f = root.querySelector('form');
    function update() {
      var r = estimate({
        dev: +f.dev.value, per: +f.per.value, trial: f.trial.checked,
        gb: +f.gb.value, newco: f.newco.checked
      });
      root.querySelector('[data-out="mgmt"]').textContent = r.mgmt;
      root.querySelector('[data-out="data"]').textContent = r.data;
      root.querySelector('[data-out="total"]').textContent = r.total;
      root.querySelector('[data-out="pack"]').textContent = s.packsN.replace('{n}', r.packs).replace('{d}', s.dur[r.packIdx]);
      return r;
    }
    var t;
    f.addEventListener('input', function () { var r = update(); clearTimeout(t); t = setTimeout(function () { track('rms_calculator', r); }, 800); });
    update();
  }

  function initReferralField() {
    var ref = null;
    try { ref = sessionStorage.getItem('tefco_teltonika_ref'); } catch (e) {}
    document.querySelectorAll('[data-tefco-ref-field]').forEach(function (el) {
      el.value = ref ? 'Teltonika Where to Buy (' + ref + ')' : '';
    });
  }

  function initQuotePrefill() {
    var ta = document.querySelector('[data-tefco-cart-prefill]');
    if (!ta || !/from=cart/.test(location.search)) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        ta.value = c.items.map(function (i) { return (i.sku || i.handle) + ' — ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : '') + ' × ' + i.quantity; }).join('\n');
      }).catch(function () {});
  }

  function initSelectTracking() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-tefco-select]');
      if (a) track('select_item', { item_list_id: 'rms', item_id: a.getAttribute('data-tefco-select') });
    });
  }

  // Price guard: when the product's price is pending, hide Dawn's add-to-cart and offer a quote.
  // Server-side safety: pending products also stay in Draft status (see README).
  function initPriceGuard() {
    var flag = document.querySelector('.tefco-price[data-price-pending="true"]');
    if (!flag) return;
    document.querySelectorAll('product-form .product-form__submit, .shopify-payment-button').forEach(function (b) { b.hidden = true; b.disabled = true; });
    var form = document.querySelector('product-form');
    if (form && !form.querySelector('.tefco-request-price')) {
      var a = document.createElement('a');
      a.className = 'button button--full-width tefco-request-price';
      a.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'pages/quote';
      a.textContent = flag.getAttribute('data-label') || 'Request price';
      form.appendChild(a);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPriceGuard();
    document.querySelectorAll('[data-tefco-selector]').forEach(initSelector);
    document.querySelectorAll('[data-tefco-calc]').forEach(initCalc);
    initReferralField();
    initQuotePrefill();
    initSelectTracking();
  });

  if (typeof module !== 'undefined') module.exports = { recommend: recommend, estimate: estimate };
})();


/* Header dropdowns: open on hover for mouse users on desktop. Click / keyboard still work as normal. */
(function () {
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  function setOpen(d, open) {
    var s = d.querySelector('summary');
    if (open) { d.setAttribute('open', ''); } else { d.removeAttribute('open'); }
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function init() {
    document.querySelectorAll('.header__inline-menu details[id^="Details-HeaderMenu-"]').forEach(function (d) {
      if (d.dataset.tefcoHover) return;
      d.dataset.tefcoHover = '1';
      var timer;
      d.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details[open][id^="Details-HeaderMenu-"]').forEach(function (o) { if (o !== d) setOpen(o, false); });
        setOpen(d, true);
      });
      d.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        timer = setTimeout(function () { setOpen(d, false); }, 180);
      });
      d.addEventListener('click', function (e) {
        var s = e.target.closest('summary');
        if (!s || s.parentElement !== d) return;
        if (mq.matches && e.detail > 0 && d.hasAttribute('open')) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
